import getForms from './getForms'
import getONBForms from './getONBForms'

export const getFormsPromise = getForms
export const getONBFormsPromise = getONBForms
